import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { Text } from '../../../components/common/atom/Text';
import { Flex } from '../../../components/common/atom/Layout';
import { CheckIcon } from '../../../components/common/atom/Icon';
import PageTemplate from '../../../components/common/template/PageTemplate';
import ReviewListView from './ReviewListView';

import { formatDate, calculateDateFromCurrent } from '../../../lib/util/Date';
import { getCDNUrl } from '../../../lib/image/CDNUrl';
import { useGetReviewCount } from '../../../Hooks/useReview';
import { EVENT_DETAIL, MYPAGE_REVIEW } from '../../../lib/routes/path';
import { ID_REVIEW_CONTEST } from '../../event/EventReviewContestData';
import { isReviewContestOn } from '../../../lib/image/event/EventReviewContestIcon';
import { REVIEW_BANNER_REVIEW_CONTEST } from '../../../lib/image/event/EventReviewContestImages';

export const getReviewListApi = `/review/search`;

const ReviewList = () => {
  const [sort, setSort] = useState(POPULAR);
  const [criteria, setCriteria] = useState(POPULAR_CRITERIA);
  const sortBy = sort === POPULAR ? POPULAR_SORT_BY : DEFAULT_SORT_BY;
  const sortDirection =
    sort === POPULAR ? POPULAR_SORT_DIRECTION : DEFAULT_SORT_DIRECTION;

  const { reviewCount } = useGetReviewCount();

  const onCheckAfterBirth = () => {
    const filterIndex = sort === FILTER_LIST[2].sortType ? 0 : 2;

    setSort(FILTER_LIST[filterIndex].sortType);
    setCriteria(FILTER_LIST[filterIndex].criteriaType);
  };

  return (
    <PageTemplate noMargin title={'리뷰 목록'}>
      <Flex column padding="1.25rem 0 2.5rem" alignItems="stretch">
        <Text
          weight="bold"
          size={16}
          style={{ margin: '0 0 0.625rem 1.25rem' }}
        >
          <b>{reviewCount.toLocaleString()}</b> 개의 리뷰
        </Text>
        <ReviewPageBanner />
        <Flex column padding="1.5625rem 0 0" alignItems="stretch">
          <Flex padding="0 1.25rem" justifyContent="space-between">
            <Flex onClick={onCheckAfterBirth} style={{ cursor: 'pointer' }}>
              <CheckIcon
                defaultBackgroundColor="pinkishGrey"
                checked={sort === FILTER_LIST[2].sortType}
              />
              <Text
                weight="medium"
                size={14}
                style={{ marginLeft: '0.313rem' }}
                color={
                  sort === FILTER_LIST[2].sortType ? 'orangePink' : 'darkest'
                }
              >
                출산 후 비교
              </Text>
            </Flex>
            <Flex justifyContent="end" style={{ cursor: 'pointer' }}>
              {FILTER_LIST.slice(0, 2).map((item, idx) => {
                const { sortType, title, criteriaType } = item;
                return (
                  <React.Fragment key={idx}>
                    <Text
                      weight="medium"
                      size={14}
                      style={{ marginLeft: '0.313rem' }}
                      color={sort === sortType ? 'orangePink' : 'pinkishGrey'}
                      onClick={() => {
                        setSort(sortType);
                        setCriteria(criteriaType);
                      }}
                    >
                      {title}
                    </Text>
                    {title === '인기순' && (
                      <Text
                        color="pinkishGrey"
                        style={{ marginLeft: '0.313rem' }}
                      >
                        |
                      </Text>
                    )}
                  </React.Fragment>
                );
              })}
            </Flex>
          </Flex>
          <ReviewListView
            criteria={criteria}
            sortBy={sortBy}
            sortDirection={sortDirection}
          />
        </Flex>
      </Flex>
    </PageTemplate>
  );
};

export default React.memo(ReviewList);

const POPULAR = `popular`;
const LATEST = `latest`;
const AFTER_BIRTH = `afterBirth`;

const DEFAULT_CRITERIA = 'nation<EQ>KOREA';
export const POPULAR_CRITERIA = ``;
const AFTER_BIRTH_CRITERIA = `${DEFAULT_CRITERIA},reviewCategory.name<EQ>BABYFACE_AFTER_BIRTH`;

const DEFAULT_SORT_BY = 'createDateTime';
export const POPULAR_SORT_BY =
  'adminVariable.bestReviewPriority,likesCount,createDateTime';

const DEFAULT_SORT_DIRECTION = 'DESC';
export const POPULAR_SORT_DIRECTION = 'DESC,DESC,DESC';

const FILTER_LIST = [
  [POPULAR, '인기순', POPULAR_CRITERIA],
  [LATEST, '최신순', DEFAULT_CRITERIA],
  [AFTER_BIRTH, '출산 후 비교', AFTER_BIRTH_CRITERIA],
].map((item) => ({ sortType: item[0], title: item[1], criteriaType: item[2] }));

export const ReviewPageBanner = () => {
  const link = isReviewContestOn()
    ? `${EVENT_DETAIL}/${ID_REVIEW_CONTEST}`
    : MYPAGE_REVIEW;

  const bannerSrc = isReviewContestOn()
    ? REVIEW_BANNER_REVIEW_CONTEST.src
    : getCDNUrl('reviews', 'payback_banner.jpg');

  return (
    <Link to={link}>
      <img src={bannerSrc} width="100%" alt="리뷰 페이지 배너 이미지" />
    </Link>
  );
};
